import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import FileOpenRoundedIcon from "@mui/icons-material/FileOpenRounded";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Chip,
  CircularProgress,
  Divider,
  Grid,
  Modal,
  Paper,
  TextField,
  Typography,
  styled,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Switch,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { decode } from "base-64";
import { useFormik } from "formik";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "../api";
import { fetchToken } from "../auth/Token";
import SendRoundedIcon from '@mui/icons-material/SendRounded';
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(2),
  borderStyle: "groove",
  border: "3px",
  borderColor: "grey",
  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2), 0 6px 20px rgba(0, 0, 0, 0.2)",
  marginTop: "10px",
  marginBottom: "10px",
  minHeight: "50px",
  borderRadius: "10px",
}));


const ExpenseDisbursementDialog = ({ 
    open, 
    onClose, 
    expenseData,
    onDisburse,
    note,
    closeData 
  }) => {
    const [accounts, setAccounts] = useState([]);
    const [selectedAccount, setSelectedAccount] = useState(null);
    const [loading, setLoading] = useState(false);
    const [showAccounts, setShowAccounts] = useState(false);

  const currencyFormat = new Intl.NumberFormat("en-GH", {
    style: "currency",
    currency: "GHS",
  });

  useEffect(() => {
    if (open) {
      fetchAccounts();
    }
  }, [open]);

  const fetchAccounts = () => {
    toast.promise(
      api.get("/association/society/all", {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      }),
      {
        loading: "Loading accounts...",
        success: (response) => {
          setAccounts(response.data);
          return "Accounts loaded";
        },
        error: (error) => {
          console.error(error);
          return "Failed to load accounts";
        },
      }
    );
  };

  const handleDisburse = () => {
    if (!selectedAccount) {
      toast.error("Please select account");
      return;
    }

    setLoading(true);

    const formData = new FormData();
    formData.append("transactions_id", expenseData.id);

    formData.append("note", note || "");

    if (selectedAccount.type === "ecash") {
      formData.append("ecash_id", selectedAccount.id);
    } else {
      formData.append("bank_id", selectedAccount.id);
    }

    toast.promise(
      api.post("/account/disburse/funds", formData, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      }),
      {
        loading: "Processing disbursement...",
        success: (response) => {
          onDisburse();
          onClose();
          closeData();
          return response.data;
        },
        error: (error) => {
          console.error(error);
          return "Disbursement failed";
        },
        finally: () => setLoading(false),
      }
    );
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
          <b>Disburse Expense</b>
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Box sx={{ mb: 3 }}>
          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
            <b>Expense Details:</b>
          </Typography>
          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
            <b>Requestor: {expenseData.user_name}</b>
          </Typography>
          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
            <b>Purpose: {expenseData.ledger}</b>
          </Typography>
          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
            <b>Amount: {currencyFormat.format(expenseData.recommended_amount || expenseData.amount)}</b>
          </Typography>
          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
            <b>Narration: {expenseData.narration}</b>
          </Typography>
        </Box>

        {/* <TextField
          fullWidth
          margin="normal"
          type="datetime-local"
          label="Disbursement Date"
          InputLabelProps={{ shrink: true }}
          value={disbursementDate}
          onChange={(e) => setDisbursementDate(e.target.value)}
          required
        /> */}

        <Box sx={{ display: "flex", alignItems: "center", mt: 2 }}>
          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
            <b>Select Disbursement Account</b>
          </Typography>
          <Switch
            checked={showAccounts}
            onChange={() => setShowAccounts(!showAccounts)}
            color="primary"
          />
        </Box>

        {showAccounts && (
          <Box sx={{ mt: 2, p: 2, border: "1px solid #eee", borderRadius: 1 }}>
            <Typography
              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
              sx={{ mb: 2 }}
            >
              <b>Available Accounts</b>
            </Typography>

            {accounts?.Main && (
              <Box sx={{ mb: 2 }}>
                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                  <b>Main Wallet</b>
                </Typography>
                <Chip
                  label={currencyFormat.format(accounts.Main.current_balance)}
                  onClick={() =>
                    setSelectedAccount({ ...accounts.Main, type: "ecash" })
                  }
                  color={
                    selectedAccount?.id === accounts.Main.id
                      ? "primary"
                      : "default"
                  }
                  variant={
                    selectedAccount?.id === accounts.Main.id
                      ? "filled"
                      : "outlined"
                  }
                  sx={{ mr: 1, mb: 1 }}
                />
              </Box>
            )}

            {accounts?.Accounts?.length > 0 && (
              <Box>
                <Typography
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  sx={{ mb: 1 }}
                >
                  <b>Bank Accounts</b>
                </Typography>
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                  {accounts.Accounts.map((account) => (
                    <Chip
                      key={account.id}
                      label={`${account.account_name} - ${currencyFormat.format(
                        account.current_balance
                      )}`}
                      onClick={() =>
                        setSelectedAccount({ ...account, type: "bank" })
                      }
                      color={
                        selectedAccount?.id === account.id
                          ? "primary"
                          : "default"
                      }
                      variant={
                        selectedAccount?.id === account.id
                          ? "filled"
                          : "outlined"
                      }
                    />
                  ))}
                </Box>
              </Box>
            )}
          </Box>
        )}

        {selectedAccount && (
          <Box
            sx={{ mt: 2, p: 2, backgroundColor: "#f5f5f5", borderRadius: 1 }}
          >
            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
              <b>Selected Account: {selectedAccount.account_name}</b>
            </Typography>
            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
              <b>
                Current Balance:{" "}
                {currencyFormat.format(selectedAccount.current_balance)}
              </b>
            </Typography>
            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
              <b>
                Amount After Disbursement:{" "}
                {currencyFormat.format(
                  selectedAccount.current_balance - 
                  (expenseData.recommended_amount || expenseData.amount)
                )}
              </b>
            </Typography>
          </Box>
        )}
      </DialogContent>

      <DialogActions>
        <Button
          onClick={onClose}
          startIcon={<CancelRoundedIcon />}
          color="error"
          variant="outlined"
        >
          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
            <b>Cancel</b>
          </Typography>
        </Button>
        <Button
          onClick={handleDisburse}
          startIcon={loading ? <CircularProgress size={20} /> : <SendRoundedIcon />}
          color="primary"
          variant="contained"
          disabled={loading || !selectedAccount}
        >
          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
            <b>Disburse</b>
          </Typography>
        </Button>
      </DialogActions>
    </Dialog>
  );
};


const DisbursementDialog = ({ open, onClose, loanData, onDisburse, note, closeData }) => {
  const [accounts, setAccounts] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [repaymentStartDate, setRepaymentStartDate] = useState("");
  const [repaymentPeriod, setRepaymentPeriod] = useState("");
  const [repaymentPeriodType, setRepaymentPeriodType] = useState("weeks");
  const [interestPeriod, setInterestPeriod] = useState("");
  const [loading, setLoading] = useState(false);
  const [showAccounts, setShowAccounts] = useState(false);
  
  const currencyFormat = new Intl.NumberFormat("en-GH", {
    style: "currency",
    currency: "GHS",
  });

  useEffect(() => {
    if (open) {
      fetchAccounts();
    }
  }, [open]);

  const fetchAccounts = () => {
    toast.promise(
      api.get("/association/society/all", {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      }),
      {
        loading: "Loading accounts...",
        success: (response) => {
          setAccounts(response.data);
          return "Accounts loaded";
        },
        error: (error) => {
          console.error(error);
          return "Failed to load accounts";
        },
      }
    );
  };

  const handleDisburse = () => {
    if (
      !repaymentStartDate ||
      !repaymentPeriod ||
      !interestPeriod ||
      !selectedAccount
    ) {
      toast.error("Please fill all required fields");
      return;
    }

    setLoading(true);

    const formData = new FormData();
    formData.append("transaction_id", loanData.transaction_id || loanData.id);
    formData.append("repayment_starts", repaymentStartDate);
    formData.append("num_of_weeks_to_end_payment", repaymentPeriod);
    formData.append("interest_period", interestPeriod);
    formData.append("repaymentTimes", repaymentPeriodType);
    formData.append("note", note || "");
    if(loanData.request_type === "Group Loan"){
        formData.append("group_id", loanData.group_id);
        formData.append("types", "cash");
    }

    if (selectedAccount.type === "ecash") {
      formData.append("ecash_id", selectedAccount.id);
    } else {
      formData.append("bank_id", selectedAccount.id);
    }
    // console.log(loanData)

    toast.promise(
      api.patch("/transactions/disburse/loan", formData, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      }),
      {
        loading: "Processing disbursement...",
        success: (response) => {
          onDisburse();
          onClose();
          closeData();
          fetchAccounts();
          setSelectedAccount(null)
          setRepaymentStartDate("")
          setRepaymentPeriod("")
          setInterestPeriod("")
          setShowAccounts(false)
          return response.data;
        },
        error: (error) => {
          console.error(error);
          return "Disbursement failed";
        },
        finally: () => setLoading(false),
      }
    );
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
          <b>Disburse Loan</b>
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Box sx={{ mb: 3 }}>
          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
            <b>Loan Details:</b>
          </Typography>
          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
            <b>Borrower: {loanData.member_name || loanData.group_name}</b>
          </Typography>
          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
            <b>
              Amount:{" "}
              {currencyFormat.format(loanData.amount || loanData.total_amount)}
            </b>
          </Typography>
          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
            <b>Savings Group: {loanData.association_name}</b>
          </Typography>
        </Box>

        <TextField
          fullWidth
          margin="normal"
          type="date"
          label="Repayment Start Date"
          InputLabelProps={{ shrink: true }}
          value={repaymentStartDate}
          onChange={(e) => setRepaymentStartDate(e.target.value)}
          required
        />

        <FormControl component="fieldset" sx={{ mt: 2 }}>
          <FormLabel component="legend">
            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
              <b>Repayment Period Type</b>
            </Typography>
          </FormLabel>
          <RadioGroup
            row
            value={repaymentPeriodType}
            onChange={(e) => setRepaymentPeriodType(e.target.value)}
          >
            <FormControlLabel
              value="weeks"
              control={<Radio />}
              label={
                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                  <b>Weeks</b>
                </Typography>
              }
            />
            <FormControlLabel
              value="months"
              control={<Radio />}
              label={
                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                  <b>Months</b>
                </Typography>
              }
            />
          </RadioGroup>
        </FormControl>

        <TextField
          fullWidth
          margin="normal"
          type="number"
          label={`Repayment Period (${repaymentPeriodType})`}
          value={repaymentPeriod}
          onChange={(e) => setRepaymentPeriod(e.target.value)}
          required
        />

        <TextField
          fullWidth
          margin="normal"
          type="number"
          label={`Interest Period (${repaymentPeriodType})`}
          value={interestPeriod}
          onChange={(e) => setInterestPeriod(e.target.value)}
          required
        />

        <Box sx={{ display: "flex", alignItems: "center", mt: 2 }}>
          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
            <b>Select Disbursement Account</b>
          </Typography>
          <Switch
            checked={showAccounts}
            onChange={() => setShowAccounts(!showAccounts)}
            color="primary"
          />
        </Box>

        {showAccounts && (
          <Box sx={{ mt: 2, p: 2, border: "1px solid #eee", borderRadius: 1 }}>
            <Typography
              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
              sx={{ mb: 2 }}
            >
              <b>Available Accounts</b>
            </Typography>

            {accounts?.Main && (
              <Box sx={{ mb: 2 }}>
                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                  <b>Main Wallet</b>
                </Typography>
                <Chip
                  label={currencyFormat.format(accounts.Main.current_balance)}
                  onClick={() =>
                    setSelectedAccount({ ...accounts.Main, type: "ecash" })
                  }
                  color={
                    selectedAccount?.id === accounts.Main.id
                      ? "primary"
                      : "default"
                  }
                  variant={
                    selectedAccount?.id === accounts.Main.id
                      ? "filled"
                      : "outlined"
                  }
                  sx={{ mr: 1, mb: 1 }}
                />
              </Box>
            )}

            {accounts?.Accounts?.length > 0 && (
              <Box>
                <Typography
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  sx={{ mb: 1 }}
                >
                  <b>Bank Accounts</b>
                </Typography>
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                  {accounts.Accounts.map((account) => (
                    <Chip
                      key={account.id}
                      label={`${account.account_name} - ${currencyFormat.format(
                        account.current_balance
                      )}`}
                      onClick={() =>
                        setSelectedAccount({ ...account, type: "bank" })
                      }
                      color={
                        selectedAccount?.id === account.id
                          ? "primary"
                          : "default"
                      }
                      variant={
                        selectedAccount?.id === account.id
                          ? "filled"
                          : "outlined"
                      }
                    />
                  ))}
                </Box>
              </Box>
            )}
          </Box>
        )}

        {selectedAccount && (
          <Box
            sx={{ mt: 2, p: 2, backgroundColor: "#f5f5f5", borderRadius: 1 }}
          >
            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
              <b>Selected Account: {selectedAccount.account_name}</b>
            </Typography>
            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
              <b>
                Current Balance:{" "}
                {currencyFormat.format(selectedAccount.current_balance)}
              </b>
            </Typography>
          </Box>
        )}
      </DialogContent>

      <DialogActions>
        <Button
          onClick={onClose}
          startIcon={<CancelRoundedIcon />}
          color="error"
          variant="outlined"
        >
          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
            <b>Cancel</b>
          </Typography>
        </Button>
        <Button
          onClick={handleDisburse}
          startIcon={loading ? <CircularProgress size={20} /> : <SendRoundedIcon />}
          color="primary"
          variant="contained"
          disabled={loading || !selectedAccount}
        >
          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
            <b>Disburse</b>
          </Typography>
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const CashierDashboard = () => {
  const [loan_data, setLoan_data] = useState([]);
  const [team_data, setTeam_data] = useState([]);
  const [show_one, setShow_one] = useState(false);
  const [viewPV, setViewPV] = useState(false);
  const [disbursementOpen, setDisbursementOpen] = useState(false);
  const [expenseDisbursementOpen, setExpenseDisbursementOpen] = useState(false);

  const handleExpenseDisburse = () => {
    setExpenseDisbursementOpen(true);
  };
  
  const handleExpenseDisbursementComplete = () => {
    setExpenseDisbursementOpen(false);
    getMyData();
  };


  const closeData = () => {
    setShow_one(false);
    setLoan_data([]);
    formik.handleReset();
  }

  const handleDisburse = () => {
    setDisbursementOpen(true);
  };

  const handleDisbursementComplete = () => {
    setDisbursementOpen(false);
    getMyData();
  };

  const printRef = React.useRef();

  const handlePrint = async () => {
    const element = printRef.current;
    const canvas = await html2canvas(element);
    const data = canvas.toDataURL("image/png");

    const pdf = new jsPDF();
    const imgProperties = pdf.getImageProperties(data);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProperties.height * pdfWidth) / imgProperties.width;

    const pageHeight = pdf.internal.pageSize.getHeight();
    const marginLeft = 10;
    const marginTop = 10;
    const marginRight = 10;
    const marginBottom = 10;
    let yOffset = 0;
    let pageNumber = 1;

    while (yOffset < pdfHeight) {
      if (pageNumber > 1) {
        pdf.addPage();
      }

      pdf.addImage(
        data,
        "PNG",
        marginLeft,
        marginTop - yOffset,
        pdfWidth - marginLeft - marginRight,
        pdfHeight - marginTop - marginBottom
      );

      // Add page label
      pdf.setFontSize(8); // Make the font size smaller
      pdf.text(
        `Page ${pageNumber}`,
        marginLeft - 9,
        pageHeight - marginBottom + 5
      );

      yOffset += pageHeight - marginTop - marginBottom;
      pageNumber++;
    }

    pdf.save("PV.pdf");
  };

  const handleClosePV = () => {
    setViewPV(false);
  };

  const handleOpenDetails = (row) => {
    setLoan_data(row);
    setShow_one(true);
    formik.setFieldValue("request_id", row.id);
  };

  const getMyData = () => {
    toast.promise(
      api.get("/association/cashier/data", {
        headers: {
          Authorization: "Bearer " + fetchToken(),
          "Content-Type": "multipart/form-data",
        },
      }),
      {
        loading: "Loading Your Dashboard",
        success: (response) => {
          setTeam_data(response.data);
          // console.log(response.data)

          return "Dashboard Loaded Successfully";
        },
        error: (error) => {
          console.error(error);
          return "Error, please try again";
        },
      }
    );
  };

  useEffect(() => {
    getMyData();
  }, []);

  const currencyFormat = new Intl.NumberFormat("en-GH", {
    style: "currency",
    currency: "GHS",
  });

  const pic = (pic) => {
    const de = decode(pic);
    return `data:image/jpeg;base64,${btoa(de)}`;
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { xs: "90%", sm: "90%", md: 900 },
    maxHeight: "80vh",
    minHeight: "70vh",
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      width: "7px",
    },
    "&::-webkit-scrollbar-track": {
      background: "#f1f1f1",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#888",
      borderRadius: "10px",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: "#555",
    },
    bgcolor: "background.paper",
    borderRadius: "7px",
    boxShadow: 24,
    p: 4,
  };

  function formatDateToYearMonthDay(date) {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    let suffix = "th";
    if (day === 1 || day === 21 || day === 31) suffix = "st";
    else if (day === 2 || day === 22) suffix = "nd";
    else if (day === 3 || day === 23) suffix = "rd";
    return `${day}${suffix} ${month} ${year}`;
  }

  const formik = useFormik({
    initialValues: {
      request_id: null,
      amount_recommending: null,
      note: "",
    },
    onSubmit: (values) => {
      const data = new FormData();
      data.append("id", values.request_id);
      if (values.amount_recommending) {
        data.append("recommended_amount", values.amount_recommending);
      }
      data.append("note", values.note);

      toast.promise(
        api.post("/association/request/approved", data, {
          headers: {
            Authorization: "Bearer " + fetchToken(),
            "Content-Type": "multipart/form-data",
          },
        }),
        {
          loading: "Processing request...",
          success: (response) => {
            setShow_one(false);
            setLoan_data([]);
            formik.handleReset();
            getMyData();

            return response.data;
          },
          error: (error) => {
            console.log(error);

            return "Error, Please try again";
          },
        }
      );
    },
  });

  return (
    <div className="app">
      <main className="content">
        <Box sx={{ m: 5 }}>
          {/* HEADER */}
          <Box>
            <Typography
              variant="h3"
              sx={{ textAlign: "center", m: 1 }}
              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
            >
              <b>My Dashboard</b>
            </Typography>
          </Box>
          {/* Main Content */}
          <Grid container spacing={1}>
            {/* list of things */}
            <Grid item xs={12} md={8}>
              <Item>
                <Typography
                  variant="h5"
                  sx={{ textAlign: "center", m: 1 }}
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                >
                  <b>Active Requests</b>
                </Typography>

                <Divider variant="middle" sx={{ my: 4 }}>
                  <Typography
                    variant="caption"
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  >
                    <b>Groups Loan Requests</b>
                  </Typography>
                </Divider>
                <Box sx={{ display: "flex", flexDirection: "row" }}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      overflowX: "auto",
                      "&::-webkit-scrollbar": {
                        width: "7px",
                      },
                      "&::-webkit-scrollbar-track": {
                        background: "#f1f1f1",
                      },
                      "&::-webkit-scrollbar-thumb": {
                        background: "#888",
                        borderRadius: "10px",
                      },
                      "&::-webkit-scrollbar-thumb:hover": {
                        background: "#555",
                      },
                    }}
                  >
                    {!team_data?.group_loans ? (
                      <Typography
                        sx={{ m: 1 }}
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                      >
                        <b>No Group Loans Available</b>
                      </Typography>
                    ) : null}
                    {team_data &&
                      team_data?.group_loans?.map((item) => (
                        <Box sx={{ mx: 3 }}>
                          <Item>
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between",
                              }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <Typography
                                  variant="h5"
                                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                >
                                  <b>{item.group_name}</b>
                                </Typography>
                                <Typography
                                  variant="caption"
                                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                >
                                  <b>Savings Group: {item.association_name}</b>
                                </Typography>
                              </Box>
                              <Box sx={{ px: 5 }}></Box>
                              <Box>
                                <Button
                                  size="small"
                                  color="success"
                                  variant="contained"
                                  sx={{
                                    borderRadius: 2,
                                    boxShadow:
                                      "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                    "&:hover": {
                                      boxShadow:
                                        "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                      backgroundColor: "#14213d",
                                    },
                                  }}
                                  onClick={() => handleOpenDetails(item)}
                                >
                                  <FileOpenRoundedIcon />
                                </Button>
                              </Box>
                            </Box>
                          </Item>
                        </Box>
                      ))}
                  </Box>
                </Box>
                <Divider variant="middle">
                  <Typography
                    variant="caption"
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  >
                    <b>Individual Loans Requests</b>
                  </Typography>
                </Divider>

                <Box
                  sx={{
                    overflow: "auto",
                    marginBottom: 10,
                    maxHeight: 340,
                    "&::-webkit-scrollbar": {
                      width: "7px",
                      height: "7px",
                    },
                    "&::-webkit-scrollbar-track": {
                      background: "#f1f1f1",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      background: "#888",
                      borderRadius: "10px",
                    },
                    "&::-webkit-scrollbar-thumb:hover": {
                      background: "#555",
                    },
                  }}
                >
                  {!team_data?.loans ? (
                    <Typography
                      sx={{ m: 1 }}
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                      <b>No Individual Loans Available</b>
                    </Typography>
                  ) : null}

                  <Table size="small" aria-label="a dense table">
                    <TableHead>
                      <TableRow>
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>No.</b>
                          </Typography>{" "}
                        </TableCell>
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Request Date</b>
                          </Typography>{" "}
                        </TableCell>
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Loan Product</b>
                          </Typography>{" "}
                        </TableCell>
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Amount</b>
                          </Typography>{" "}
                        </TableCell>
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Member</b>
                          </Typography>{" "}
                        </TableCell>
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Savings Group</b>
                          </Typography>{" "}
                        </TableCell>
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Group Name</b>
                          </Typography>{" "}
                        </TableCell>
                        {/* <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Cluster</b>
                                        </Typography>{" "}
                                    </TableCell> */}
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Open</b>
                          </Typography>{" "}
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {team_data?.loans?.map((row, index) => (
                        <TableRow
                          key={row.index}
                          sx={{
                            "&:last-child td, &:last-child th": {
                              border: 0,
                            },
                            backgroundColor: "#f5f3f4",
                          }}
                        >
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>{index + 1}</b>
                            </Typography>
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>
                                {formatDateToYearMonthDay(
                                  new Date(row.transaction_date)
                                )}
                              </b>
                            </Typography>
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>{row.account_name}</b>
                            </Typography>
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>{currencyFormat.format(row.recommended_amount? row.recommended_amount :row.amount)}</b>
                            </Typography>
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>{row.member_name}</b>
                            </Typography>
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>{row.association_name}</b>
                            </Typography>
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>{row.group_name}</b>
                            </Typography>
                          </TableCell>
                          {/* <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>{row.cluster_name}</b>
                                        </Typography>
                                        </TableCell> */}
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <Button
                                size="small"
                                color="success"
                                variant="contained"
                                sx={{
                                  borderRadius: 2,
                                  boxShadow:
                                    "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                  "&:hover": {
                                    boxShadow:
                                      "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                    backgroundColor: "#14213d",
                                  },
                                }}
                                onClick={() => handleOpenDetails(row)}
                              >
                                <FileOpenRoundedIcon />
                              </Button>
                            </Typography>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </Box>
                <Divider variant="middle">
                          <Typography
                              variant="caption"
                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                          >
                              <b>Expense Requests</b>
                          </Typography>
                        </Divider>
                        <Box
                                sx={{
                                overflow: "auto",
                                marginBottom: 10,
                                maxHeight: 340,
                                "&::-webkit-scrollbar": {
                                    width: "7px",
                                    height: "7px",
                                },
                                "&::-webkit-scrollbar-track": {
                                    background: "#f1f1f1",
                                },
                                "&::-webkit-scrollbar-thumb": {
                                    background: "#888",
                                    borderRadius: "10px",
                                },
                                "&::-webkit-scrollbar-thumb:hover": {
                                    background: "#555",
                                },
                                }}
                            >
                                {!team_data?.expenses ? (
                                <Typography
                                    sx={{ m: 1 }}
                                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                >
                                    <b>No Expense Request Available</b>
                                </Typography>
                                ) : null}

                                <Table size="small" aria-label="a dense table">
                                <TableHead>
                                    <TableRow>
                                    <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>No.</b>
                                        </Typography>{" "}
                                    </TableCell>
                                    <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Request Date</b>
                                        </Typography>{" "}
                                    </TableCell>
                                    <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Purpose</b>
                                        </Typography>{" "}
                                    </TableCell>
                                    <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Amount</b>
                                        </Typography>{" "}
                                    </TableCell>
                                    <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Narration</b>
                                        </Typography>{" "}
                                    </TableCell>
                                    <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>User Name</b>
                                        </Typography>{" "}
                                    </TableCell>
                                    <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Open</b>
                                        </Typography>{" "}
                                    </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {team_data?.expenses?.map((row, index) => (
                                    <TableRow
                                        key={row.index}
                                        sx={{
                                        "&:last-child td, &:last-child th": {
                                            border: 0,
                                        },
                                        backgroundColor: "#f5f3f4",
                                        }}
                                    >
                                        <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>{index + 1}</b>
                                        </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>{formatDateToYearMonthDay(new Date(row.request_date))}</b>
                                        </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>{row.ledger}</b>
                                        </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>{currencyFormat.format(row.recommended_amount? row.recommended_amount :row.amount)}</b>
                                        </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>{row.narration}</b>
                                        </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>{row.user_name}</b>
                                        </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <Button
                                                  size="small"
                                                  color="success"
                                                  variant="contained"
                                                  sx={{
                                                  borderRadius: 2,
                                                  boxShadow:
                                                      "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                                  "&:hover": {
                                                      boxShadow:
                                                      "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                                      backgroundColor: "#14213d",
                                                  },
                                                  }}
                                                  onClick={() => handleOpenDetails(row)}
                                              >
                                                  <FileOpenRoundedIcon />
                                              </Button>
                                          </Typography>
                                        </TableCell>
                                        
                                    </TableRow>
                                    ))}
                                </TableBody>
                                </Table>
                            </Box>
              </Item>
            </Grid>
            {/* Details Board */}
            <Grid item xs={12} md={4}>
              <Item>
                <Typography
                  variant="h4"
                  sx={{ textAlign: "center", m: 1 }}
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                >
                  <b>Loan Details</b>
                </Typography>
                {!show_one && (
                  <Typography
                    variant="caption"
                    sx={{ textAlign: "center" }}
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  >
                    <b>Open Group Or Individual Loan To View Details</b>
                  </Typography>
                )}
                <Divider variant="middle" sx={{ my: 3 }} />
                {loan_data.request_type === "Loan" ? (
                  <Grid container spacing={1}>
                    <Grid item xs={12} md={6}>
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>
                          Requesting Amount:{" "}
                          {currencyFormat.format(loan_data.amount)}
                        </b>
                      </Typography>
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>
                          Recommended Amount:{" "}
                          {currencyFormat.format(loan_data.recommended_amount)}
                        </b>
                      </Typography>
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>
                          Request Date:{" "}
                          {formatDateToYearMonthDay(
                            new Date(loan_data.transaction_date)
                          )}
                        </b>
                      </Typography>
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Loan Product: {loan_data.account_name}</b>
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Cluster: {loan_data.cluster_name}</b>
                      </Typography>
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Community: {loan_data.community_name}</b>
                      </Typography>
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Savings Group: {loan_data.association_name}</b>
                      </Typography>
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Member Name: {loan_data.member_name}</b>
                      </Typography>
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Member Phone: {loan_data.member_phone}</b>
                      </Typography>
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Passbook No.: {loan_data.passbook}</b>
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={12}>
                      <Divider variant="middle" />
                    </Grid>

                    <Grid item xs={12} md={12}>
                      
                      <Button
                        size="small"
                        color="success"
                        variant="contained"
                        sx={{
                          borderRadius: 2,
                          m: 1,
                          boxShadow:
                            "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                          "&:hover": {
                            boxShadow:
                              "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                            backgroundColor: "#14213d",
                          },
                        }}
                        onClick={() => setViewPV(true)}
                      >
                        View Payment Voucher
                      </Button>
                    </Grid>

                    <Grid item xs={12} md={12}>
                      <Divider variant="middle" />
                    </Grid>
                    <Grid item xs={12} md={12}>
                      <Typography
                        variant="h4"
                        sx={{ textAlign: "center", m: 1 }}
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                      >
                        <b>Process Request</b>
                      </Typography>
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>NB: Note field is not optional</b>
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={12}>
                      <TextField
                        sx={{ m: 1 }}
                        size="small"
                        required
                        name="note"
                        type="text"
                        multiline
                        minRows={4}
                        value={formik.values.note}
                        onChange={formik.handleChange}
                        placeholder="Note here..."
                        fullWidth
                      />

                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          mt: "auto",
                        }}
                      >
                        <Button
                          size="small"
                          color="error"
                          variant="contained"
                          sx={{
                            borderRadius: 2,
                            m: 1,
                            boxShadow:
                              "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                            "&:hover": {
                              boxShadow:
                                "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                              backgroundColor: "#14213d",
                            },
                          }}
                          onClick={formik.handleReset}
                        >
                          Cancel
                        </Button>

                        <Button
                          size="small"
                          color="success"
                          variant="contained"
                          sx={{
                            borderRadius: 2,
                            m: 1,
                            boxShadow:
                              "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                            "&:hover": {
                              boxShadow:
                                "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                              backgroundColor: "#14213d",
                            },
                          }}
                          onClick={handleDisburse}
                        >
                          Disburse
                        </Button>
                      </Box>
                    </Grid>
                  </Grid>
                ) : loan_data.request_type === "Group Loan" ? (
                  <Grid container spacing={1}>
                    <Grid item xs={12} md={6}>
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>
                          Requesting Amount:{" "}
                          {currencyFormat.format(loan_data.total_amount)}
                        </b>
                      </Typography>
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>
                          Build Date:{" "}
                          {formatDateToYearMonthDay(
                            new Date(loan_data.build_date)
                          )}
                        </b>
                      </Typography>
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Loan Product: {loan_data.account_name}</b>
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Cluster: {loan_data.cluster_name}</b>
                      </Typography>
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Community: {loan_data.community_name}</b>
                      </Typography>
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Savings Group: {loan_data.association_name}</b>
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={12}>
                      <Divider variant="middle" />
                    </Grid>
                    <Grid item xs={12} md={12}>
                      
                      <Button
                        size="small"
                        color="success"
                        variant="contained"
                        sx={{
                          borderRadius: 2,
                          m: 1,
                          boxShadow:
                            "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                          "&:hover": {
                            boxShadow:
                              "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                            backgroundColor: "#14213d",
                          },
                        }}
                        onClick={() => setViewPV(true)}
                      >
                        View Payment Voucher
                      </Button>
                    </Grid>
                    <Grid item xs={12} md={12}>
                      <Divider variant="middle" />
                    </Grid>
                    <Grid item xs={12} md={12}>
                      <TextField
                        sx={{ m: 1 }}
                        size="small"
                        required
                        name="note"
                        type="text"
                        multiline
                        minRows={4}
                        value={formik.values.note}
                        onChange={formik.handleChange}
                        placeholder="Note here..."
                        fullWidth
                      />

                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          mt: "auto",
                        }}
                      >
                        <Button
                          size="small"
                          color="error"
                          variant="contained"
                          sx={{
                            borderRadius: 2,
                            m: 1,
                            boxShadow:
                              "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                            "&:hover": {
                              boxShadow:
                                "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                              backgroundColor: "#14213d",
                            },
                          }}
                          onClick={formik.handleReset}
                        >
                          Cancel
                        </Button>

                        <Button
                          size="small"
                          color="success"
                          variant="contained"
                          sx={{
                            borderRadius: 2,
                            m: 1,
                            boxShadow:
                              "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                            "&:hover": {
                              boxShadow:
                                "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                              backgroundColor: "#14213d",
                            },
                          }}
                          onClick={handleDisburse}
                        >
                          Disburse
                        </Button>
                      </Box>
                    </Grid>
                  </Grid>
                ) : loan_data.request_type === "Expense"? 
                <Grid container spacing={1}>
                  <Grid item xs={12} md={6}>
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Requested Amount: {currencyFormat.format(loan_data.amount)}</b>
                            </Typography>
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Recommended Amount: {currencyFormat.format(loan_data.recommended_amount)}</b>
                            </Typography>
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Request Date: {formatDateToYearMonthDay(new Date(loan_data.request_date))}</b>
                            </Typography>
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Purpose: {loan_data.ledger}</b>
                            </Typography>
                          </Grid>
                          <Grid item xs={12} md={6}>
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>User Name: {loan_data.user_name}</b>
                            </Typography>
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>User Phone: {loan_data.user_phone}</b>
                            </Typography>
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Role: {loan_data.user_role}</b>
                            </Typography>
                          </Grid>
                          <Grid item xs={12} md={12}>
                            <Divider variant="middle" />
                          </Grid>
                          <Grid item xs={12} md={12}>
                            <Button
                                size="small"
                                color="success"
                                variant="contained"
                                sx={{
                                borderRadius: 2,
                                m: 1,
                                boxShadow:
                                    "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                "&:hover": {
                                    boxShadow:
                                    "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                    backgroundColor: "#14213d",
                                },
                                }}
                                onClick={() => setViewPV(true)}
                            >
                              View Payment Voucher
                            </Button>
                          </Grid>
                          
                          <Grid item xs={12} md={12}>
                              <Divider variant="middle" />
                          </Grid>
                          <Grid item xs={12} md={12}>
                      <TextField
                        sx={{ m: 1 }}
                        size="small"
                        required
                        name="note"
                        type="text"
                        multiline
                        minRows={4}
                        value={formik.values.note}
                        onChange={formik.handleChange}
                        placeholder="Note here..."
                        fullWidth
                      />

                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          mt: "auto",
                        }}
                      >
                        <Button
                          size="small"
                          color="error"
                          variant="contained"
                          sx={{
                            borderRadius: 2,
                            m: 1,
                            boxShadow:
                              "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                            "&:hover": {
                              boxShadow:
                                "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                              backgroundColor: "#14213d",
                            },
                          }}
                          onClick={formik.handleReset}
                        >
                          Cancel
                        </Button>

                        <Button
                          size="small"
                          color="success"
                          variant="contained"
                          sx={{
                            borderRadius: 2,
                            m: 1,
                            boxShadow:
                              "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                            "&:hover": {
                              boxShadow:
                                "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                              backgroundColor: "#14213d",
                            },
                          }}
                          onClick={handleExpenseDisburse}
                        >
                          Disburse
                        </Button>
                      </Box>
                    </Grid>
                </Grid>
                :null}
              </Item>
            </Grid>
          </Grid>
          <Modal
            open={viewPV}
            onClose={handleClosePV}
            aria-labelledby="payment-voucher-modal"
          >
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: { xs: "95%", sm: "80%", md: "60%" },
                maxWidth: "800px",
                bgcolor: "background.paper",
                boxShadow: 24,
                p: 3,
                borderRadius: 2,
                maxHeight: "90vh",
                overflowY: "auto",
              }}
            >
              <div ref={printRef}>
                {/* Voucher Header */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 3,
                    borderBottom: "2px solid #f0f0f0",
                    pb: 2,
                  }}
                >
                    <Box>
                    <Typography 
                        variant="h4" 
                        sx={{ color: '#2c3e50' }}
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                        <b>PAYMENT VOUCHER</b>
                    </Typography>
                    <Typography 
                        variant="body2"
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                        <b>Date: {new Date().toLocaleDateString()}</b>
                    </Typography>
                </Box>
                <Box sx={{ textAlign: 'right' }}>
                    <Typography 
                        variant="h6"
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                        <b>Voucher #: PV-{loan_data?.transaction_id || loan_data?.id}</b>
                    </Typography>
                    <Chip 
                        label={loan_data?.status || 'Pending'} 
                        color={
                            loan_data?.status === 'Disbursed' ? 'success' :
                            loan_data?.status === 'Approved' ? 'primary' :
                            loan_data?.status === 'Rejected' ? 'error' : 'default'
                        }
                        size="small"
                    />
                </Box>
            </Box>

            {/* Payee Information - Different for Expense vs Loans */}
            <Box sx={{ 
                p: 2,
                mb: 3,
                border: '1px solid #f0f0f0',
                borderRadius: 1,
                backgroundColor: '#f9f9f9'
            }}>
                <Typography 
                    variant="h6"
                    sx={{ mb: 1, textDecoration: 'underline' }}
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                >
                    <b>{loan_data?.request_type === "Expense" ? "Requestor Details" : "Payee Details"}</b>
                </Typography>
                
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                        {loan_data?.request_type === "Expense" ? (
                            <>
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>Name: {loan_data?.user_name}</b>
                                </Typography>
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>Role: {loan_data?.user_role}</b>
                                </Typography>
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>Phone: {loan_data?.user_phone || 'N/A'}</b>
                                </Typography>
                            </>
                        ) : (
                            <>
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>Name: {loan_data?.member_name || loan_data?.group_name}</b>
                                </Typography>
                                {loan_data?.request_type === "Loan" && (
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Phone: {loan_data?.member_phone || 'N/A'}</b>
                                    </Typography>
                                )}
                            </>
                        )}
                    </Grid>
                    <Grid item xs={12} md={6}>
                        {loan_data?.request_type !== "Expense" && (
                            <>
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>Saving Group: {loan_data?.association_name}</b>
                                </Typography>
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>Community: {loan_data?.community_name}</b>
                                </Typography>
                            </>
                        )}
                        {loan_data?.request_type === "Expense" && (
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Expense Account: {loan_data?.account_name}</b>
                            </Typography>
                        )}
                    </Grid>
                </Grid>
            </Box>

            {/* Payment Details */}
            <Box sx={{ 
                p: 2,
                mb: 3,
                border: '1px solid #f0f0f0',
                borderRadius: 1
            }}>
                <Typography 
                    variant="h6"
                    sx={{ mb: 1, textDecoration: 'underline' }}
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                >
                    <b>Payment Details</b>
                </Typography>
                
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                        {loan_data?.request_type === "Expense" ? (
                            <>
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>Expense Account: {loan_data?.account_name}</b>
                                </Typography>
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>Request Date: {new Date(loan_data?.request_date).toLocaleDateString()}</b>
                                </Typography>
                            </>
                        ) : (
                            <>
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>Account: {loan_data?.account_name}</b>
                                </Typography>
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>Transaction Date: {new Date(loan_data?.transaction_date).toLocaleDateString()}</b>
                                </Typography>
                            </>
                        )}
                    </Grid>
                    <Grid item xs={12} md={6}>
                        {loan_data?.request_type === "Loan" ? (
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Requested Amount: {currencyFormat.format(loan_data?.amount)}</b>
                            </Typography>
                        ) : loan_data?.request_type === "Group Loan" ? (
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Total Amount: {currencyFormat.format(loan_data?.amount)}</b>
                            </Typography>
                        ) : (
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Expense Amount: {currencyFormat.format(loan_data?.amount)}</b>
                            </Typography>
                        )}
                        
                        {loan_data?.recommended_amount && (
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Recommended Amount: {currencyFormat.format(loan_data.recommended_amount)}</b>
                            </Typography>
                        )}
                    </Grid>
                </Grid>
                
                {/* Narration for Expense */}
                {loan_data?.request_type === "Expense" && loan_data?.narration && (
                    <Box sx={{ mt: 2 }}>
                        <Typography 
                            variant="subtitle2"
                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        >
                            <b>Narration:</b>
                        </Typography>
                        <Typography 
                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            sx={{ 
                                p: 1,
                                backgroundColor: '#f5f5f5',
                                borderRadius: 1,
                                borderLeft: '3px solid #1976d2'
                            }}
                        >
                            {loan_data.narration}
                        </Typography>
                    </Box>
                )}
            </Box>

            {/* Savings Information (for individual loans) */}
            {loan_data?.request_type === "Loan" && loan_data?.savings_account_list?.length > 0 && (
                <Box sx={{ 
                    p: 2,
                    mb: 3,
                    border: '1px solid #f0f0f0',
                    borderRadius: 1,
                    backgroundColor: '#f9f9f9'
                }}>
                    <Typography 
                        variant="h6"
                        sx={{ mb: 1, textDecoration: 'underline' }}
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                        <b>Savings Accounts</b>
                    </Typography>
                    
                    <Grid container spacing={2}>
                        {loan_data.savings_account_list.map((account, index) => (
                            <Grid item xs={12} key={index}>
                                <Box sx={{ 
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    p: 1,
                                    borderBottom: '1px solid #eee'
                                }}>
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>{account.account_name}</b>
                                    </Typography>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>{currencyFormat.format(account.current_balance)}</b>
                                        </Typography>
                                        <Chip 
                                            label={account.savings_performance.performance_rating}
                                            size="small"
                                            color={
                                                account.savings_performance.performance_rating === 'Excellent' ? 'success' :
                                                account.savings_performance.performance_rating === 'Good' ? 'primary' :
                                                account.savings_performance.performance_rating === 'Fair' ? 'warning' : 'error'
                                            }
                                        />
                                    </Box>
                                </Box>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            )}

            {/* Group Loan Summary (for group loans) */}
            {loan_data?.request_type === "Group Loan" && (
                <Box sx={{ 
                    p: 2,
                    mb: 3,
                    border: '1px solid #f0f0f0',
                    borderRadius: 1
                }}>
                    <Typography 
                        variant="h6"
                        sx={{ mb: 1, textDecoration: 'underline' }}
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                        <b>Group Summary</b>
                    </Typography>
                    
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Total Members: {loan_data.group_performance.member_count}</b>
                            </Typography>
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Average Savings Consistency: {loan_data.group_performance.average_consistency}%</b>
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Group Performance: {loan_data.group_performance.performance_rating}</b> 
                            </Typography>
                        </Grid>
                    </Grid>
                </Box>
            )}

                {/* Approval Section */}
                <Box
                  sx={{
                    mt: 4,
                    pt: 2,
                    borderTop: "2px dashed #ccc",
                  }}
                >
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <Box sx={{
                          p: 1,
                          borderBottom: '1px solid #ccc',
                          textAlign: 'center'
                      }}>
                          <Typography 
                            variant="body2"
                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                          >
                            <b>Prepared And Approved By(Operations Manager)</b>
                          </Typography>
                          <Box sx={{ height: '60px', mt: 1 }}></Box>
                          <Typography 
                            variant="body2"
                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                          >
                            <b>{loan_data.op}</b>
                          </Typography>
                      </Box>
                    </Grid>
                    
                    <Grid item xs={12} md={6}>
                      <Box
                        sx={{
                          p: 1,
                          borderBottom: "1px solid #ccc",
                          textAlign: "center",
                        }}
                      >
                        <Typography
                          variant="body2"
                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        >
                          <b>Disburse By(You)</b>
                        </Typography>
                        <Box sx={{ height: "60px", mt: 1 }}></Box>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </div>
              {/* Print Button */}
              <Box
                sx={{
                  mt: 3,
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  variant="contained"
                  onClick={handlePrint}
                  sx={{ mr: 2 }}
                >
                  Print Voucher
                </Button>
                <Button variant="outlined" onClick={handleClosePV}>
                  Close
                </Button>
              </Box>
            </Box>
          </Modal>
          <DisbursementDialog
            open={disbursementOpen}
            onClose={() => setDisbursementOpen(false)}
            loanData={loan_data}
            onDisburse={handleDisbursementComplete}
            note={formik.values.note}
            closeData={closeData}
          />
          <ExpenseDisbursementDialog
            open={expenseDisbursementOpen}
            onClose={() => setExpenseDisbursementOpen(false)}
            expenseData={loan_data}
            onDisburse={handleExpenseDisbursementComplete}
            note={formik.values.note}
            closeData={closeData}
          />
        </Box>
      </main>
    </div>
  );
};

export default CashierDashboard;
